import Vue from 'vue';
import AWS from 'aws-sdk';

Vue.use(AWS)
